import { ResponseService } from '../services/response.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from './../services/local-storage.service';
import { NotificationsService } from 'angular2-notifications';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Domain } from '../interfaces/domain.model';
import { FormService } from '../services/form.service';
import { DomainRecordsService } from '../services/domain-record.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-domain-details',
    templateUrl: './domain-details.component.html'
})
export class DomainDetailsComponent implements OnInit {

    public recordForm: FormGroup;
    public domainId: String;
    public modalTitle: String = 'Dodawanie domeny';
    public loadingDomainRecords: Boolean = true;
    public domain: Domain;
    public recordTypeValue: String = '';
    public record: any;
    public recordId: String = null;
    public recordKeys: Array<String> = [];
    public recordTypes = ['A', 'AAAA', 'CNAME', 'MX', 'SRV', /*'PTR'*/, 'TXT', 'NS', 'CAA'];
    public controls = {
        type: new FormControl(''),
    };

    public validators = {
        type: [Validators.required]
    };

    constructor(
        private notificationsService: NotificationsService,
        private domainRecordService: DomainRecordsService,
        private apiService: ApiService,
        private localStorageService: LocalStorageService,
        private responseService: ResponseService,
        private formService: FormService,
        private router: ActivatedRoute,
        public translate: TranslateService
    ) {
        this.recordForm = this.formService.buildForm(this.controls, this.validators);
    }

    /**
     * 
     * @memberof DomainListComponent
     */
    ngOnInit() {
        this.loadDomainRecords();
    }

    public loadDomainRecords() {
        this.domainId = '';
        this.domain = null;
        this.loadingDomainRecords = true;
        this.router.params.subscribe(params => {
            this.domainId = params['domain'];
            this.loadingDomainRecords = true;
            this.domainRecordService.getAllDomainRecords(this.domainId).subscribe(
                (domain) => {
                    this.domain = domain as Domain;
                    this.loadingDomainRecords = false;
                },
                (error) => {
                    this.notificationsService.success('Ups!', 'Błąd przy pobieraniu listy rekordów domeny');
                    this.loadingDomainRecords = false;
                }
            );
        });
    }

    public showRecordModal(modal, record?, type?) {
        this.recordForm = this.formService.buildForm(this.controls, this.validators);
        this.recordForm.controls['type'].setValue(type);
        this.recordId = null;
        if (record) {
            this.recordId = record.uuid;
            this.record = record;
            this.getRecordStructure();
            modal.open({ closeOnEscape: false });
            this.modalTitle = 'Edytowanie rekordu';
            return;
        }
        return;
        // this.getRecordStructure();
        // this.modalTitle = 'Dodawanie rekordu';
        // modal.open({ closeOnEscape: false });
    }

    public generateHint(recordField) {
        if (this.record[recordField].hint) {
            const value = this.recordForm.controls[recordField].value;
            if (value.length) {
                switch (value) {
                    case '@':
                        this.record[recordField].hintInfo = this.domain.name;
                        return;
                    default:
                        const find = '\.?' + this.domain.name.replace('.', '\\.') + '?$';
                        const regex = new RegExp(find);
                        if (!value.match(regex)) {
                            this.record[recordField].hintInfo = (value + (value.match(/\.$/) ? '' : '.') + this.domain.name);
                            return;
                        }
                        this.record[recordField].hintInfo = '';
                        return;
                }
            }
        }
        this.record[recordField].hintInfo = '';
    }

    public setHintValue(recordKey, record) {
        if (record.hint && record.hintInfo && record.hintInfo.length) {
            this.recordForm.controls[recordKey].setValue(record.hintInfo);
        }
        this.generateHint(recordKey);
    }

    public getRecordStructure() {
        const type = this.recordForm.controls['type'].value;
        for (const control in this.recordForm.controls) {
            if (control !== 'type') {
                this.recordForm.removeControl(control);
            }
        }
        if (this.recordForm.controls['type']) {
            this.record = this.domainRecordService.getStructure(type, this.record);
            let controls = {
                type: new FormControl(type),
            };

            let validators = {
                type: [Validators.required]
            };
            this.recordKeys = Object.keys(this.record);
            for (const field in this.record) {
                if (this.record.hasOwnProperty(field)) {
                    controls[field] = new FormControl(this.record[field].valueSelected ?
                        this.record[field].valueSelected : this.record[field].value);
                    validators[field] = this.record[field].validators;
                }
            }
            this.recordForm = this.formService.buildForm(controls, validators);
            for (const control in controls) {
                if (controls[control] && control !== 'type') {
                    this.generateHint(control);
                }
            }
        }
    }

    public saveDomainRecord(modal) {
        if (this.recordId) {
            this.apiService.put('/company/' + this.localStorageService.get('company') + '/domain/' + this.domainId + '/record/' + this.recordId, this.recordForm.value).subscribe(
                (response) => {
                    this.responseService.success(true, response);
                    modal.close();
                    this.loadDomainRecords();
                },
                (errors) => {
                    this.responseService.error(errors, this.recordForm);
                }
            );
            return;
        }
        this.apiService.post('/company/' + this.localStorageService.get('company') + '/domain/' + this.domainId + '/record', this.recordForm.value).subscribe(
            (response) => {
                this.responseService.success(true, response);
                modal.close();
                this.loadDomainRecords();
            },
            (errors) => {
                this.responseService.error(errors, this.recordForm);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/domain/domain-details.component.ts